import { createFileRoute, useParams } from '@tanstack/react-router';

import { InvoiceDetail } from '../components/ar/InvoiceDetail';
import { PageHead } from '../components/layout';
import { useActiveCompanyId, useArInvoice } from '../lib/queries';

export const Route = createFileRoute('/ar/invoices/$id')({
  component: ArInvoiceDetailPage,
});

export function ArInvoiceDetailPage() {
  const { id } = useParams({ from: '/ar/invoices/$id' });
  const companyId = useActiveCompanyId();
  const { data, isPending, error } = useArInvoice(companyId, id);

  if (isPending) {
    return (
      <div className="page">
        <PageHead crumbs={['ลูกหนี้การค้า']} title="ใบแจ้งหนี้" />
        <div className="muted" style={{ padding: 24, textAlign: 'center' }}>
          กำลังโหลด…
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page">
        <PageHead crumbs={['ลูกหนี้การค้า']} title="ใบแจ้งหนี้" />
        <div className="neg" style={{ padding: 24, textAlign: 'center' }}>
          โหลดไม่สำเร็จ: {error.message}
        </div>
      </div>
    );
  }

  return <div className="page">{data && <InvoiceDetail invoice={data} />}</div>;
}
